"use client";

import { OverviewBoard } from "@/components/site/sections/overview-board";
import { cn } from "@/lib/utils";

/** The Overview pillar: the product's B6 overview board for the Demo Team. */
export function OverviewPreview({
  variant,
}: {
  variant: "compact" | "expanded";
}) {
  const compact = variant === "compact";

  return (
    <div
      className={cn(
        "px-4 pt-4 sm:px-5",
        // The compact frame fades out under the fullscreen button; leave room to scroll the last row past it.
        compact ? "pb-16 sm:pt-5" : "pb-8 sm:px-6 sm:pt-6",
      )}
    >
      <OverviewBoard
        size={variant}
        lanesBleedClassName={
          compact
            ? "-mx-4 px-4 scroll-px-4 sm:-mx-5 sm:px-5 sm:scroll-px-5"
            : "-mx-4 px-4 scroll-px-4 sm:-mx-6 sm:px-6 sm:scroll-px-6"
        }
      />
    </div>
  );
}
